import { Component, OnInit } from '@angular/core';
import {
  EmailCondition,
  EmailConditionBlock
} from 'projects/app-misc/src/app/modules/admin-panel/data/email-condition';
import { MatDialog } from '@angular/material/dialog';
import { AdminPanelService } from 'projects/app-misc/src/app/modules/admin-panel/data/admin-panel.service';
import {
  SystemNfsEditorDialogComponent
} from 'projects/app-misc/src/app/modules/admin-panel/view/system-nfs-changer/system-nfs-editor-dialog/system-nfs-editor-dialog.component';
import {
  NotificationCondition,
  NotificationConditionBlock
} from 'projects/app-misc/src/app/modules/admin-panel/data/nfs-condition';
import {NfsAlertCategory} from "../../data/nfs-alert-category";

@Component({
  selector: 'app-system-nfs-changer',
  templateUrl: './system-nfs-changer.component.html',
  styleUrls: ['./system-nfs-changer.component.scss']
})
export class SystemNfsChangerComponent implements OnInit {
  conditionCategories: NfsAlertCategory[]

  loadingSpinner = true;

  constructor(
    private dialog: MatDialog,
    protected adminPanelService: AdminPanelService
  ) { }

  ngOnInit(): void {
    this.adminPanelService.getCategorizedSystemNfsAndAlertsConditions().subscribe(nfsAlertsConditions => {

      this.conditionCategories = nfsAlertsConditions;
      this.loadingSpinner = false;
    })
  }

  editEmail(condition: EmailCondition, index: number, jindex: number) {
    const dialogRef = this.dialog.open(SystemNfsEditorDialogComponent, {
      data: {
        condition
      },
      panelClass: 'nfs-changer-dialog'
    });

    dialogRef.afterClosed().subscribe(newCond => {
      if (newCond && newCond instanceof EmailCondition) {
        this.conditionCategories[index].conditions[jindex] = newCond
      }
    })
  }

}
